@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.view {
  height: 100%;
  overflow-y: auto;
  padding: 0 16px;

  & > * + * {
    margin-top: 10px;
  }
  @include c.hide-scrollbar;
}

.loadMoreBtnWrapper {
  height: #{v.$js-defined-load-more-btn-container-height}px;
}
